import { render, staticRenderFns } from "./Dashboard_Info.vue?vue&type=template&id=545648f9&scoped=true&"
import script from "./Dashboard_Info.vue?vue&type=script&lang=js&"
export * from "./Dashboard_Info.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_Info.vue?vue&type=style&index=0&id=545648f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545648f9",
  null
  
)

export default component.exports